import { CDN_URL } from "@/constants/cdn";

export const SDKConfiguration = {
  API_ENDPOINT: "https://pulse.heliumbuilder.com",
  SERVICE_ENDPOINT: "https://pulse-backend.heliumbuilder.com",
  STAGING_SERVICE_ENDPOINT: "https://dev-backend.up.railway.app",
  FLUSH_INTERVAL: 1_000 * 60,
  PulseFBPixelID: "1525074261473954",
  PulseGTAGId: "G-XXXXXXXXXX",

  get EVENTS_ENDPOINT() {
    return SDKConfiguration.SERVICE_ENDPOINT + "/data";
  },
  get INFERENCE_ENDPOINT() {
    return SDKConfiguration.SERVICE_ENDPOINT + "/infer/ui";
  },

  get DEVICE_INFO() {
    return SDKConfiguration.API_ENDPOINT + "/api/device-info";
  },

  get PING() {
    return SDKConfiguration.API_ENDPOINT + "/api/ping";
  },

  get PERSONA_INFERENCES() {
    return SDKConfiguration.SERVICE_ENDPOINT + "/infer/persona";
  },

  get BEHAVIOR_AND_ECOMM_INFERENCES() {
    return SDKConfiguration.SERVICE_ENDPOINT + "/infer/behavior-and-ecomm";
  },

  BRAND_SETTINGS(orgId: string, storeId: string) {
    return `${CDN_URL}/${orgId}/configs/settings${storeId ? "." + storeId : ""}.json`;
  },
};
